import { HttpParams } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { GerenciamientoService } from '@app/core/services/gerenciamiento.service';
import { VehiculoService } from '@app/core/services/vehiculo.service';

@Component({
  selector: 'app-flota-cards',
  standalone: false,
  templateUrl: './flota-cards.component.html',
  styleUrl: './flota-cards.component.scss'
})
export class FlotaCardsComponent implements OnInit {
  private readonly gerenciamientoService = inject(GerenciamientoService);
  private readonly vehiculoService = inject(VehiculoService);

  loading = true;

  kmsRecorridos = 0;
  gastoCombustibleLabel = 'Sin datos actualizados';
  gastoCombustibleHint = 'No hay datos actualizados de valores de la nafta.';

  vehiculosActivos = 0;
  vehiculosTotales = 0;
  porcentajeOperacion = 0;

  flotaFuncionandoAhora = 0;

  ngOnInit(): void {
    this.loadMetrics();
  }

  private loadMetrics(): void {
    this.loading = true;

    const params = new HttpParams()
      .set('page', 1)
      .set('perPage', 100000)
      .set('sortByProperty', 'id_visible')
      .set('sortBy', 'desc');

    this.gerenciamientoService.getAll(params).subscribe({
      next: (data) => {
        this.kmsRecorridos = data.entities.reduce((acc, item) => {
          const distancia = Number(item?.distancia ?? 0);
          return acc + (Number.isFinite(distancia) ? distancia : 0);
        }, 0);

        // kms only — no longer used for flotaFuncionandoAhora
        void 0;
      },
      error: () => {
        this.kmsRecorridos = 0;
      }
    });

    this.vehiculoService.getAll(params).subscribe({
      next: (data) => {
        this.vehiculosTotales = data.count || data.entities.length;
        this.vehiculosActivos = data.entities.filter((vehiculo) => vehiculo.activo === 'Activo' || Number(vehiculo.activo) === 1).length;
        this.porcentajeOperacion = this.vehiculosTotales > 0
          ? Math.round((this.vehiculosActivos / this.vehiculosTotales) * 100)
          : 0;
      },
      error: () => {
        this.vehiculosTotales = 0;
        this.vehiculosActivos = 0;
        this.porcentajeOperacion = 0;
      }
    });

    this.gerenciamientoService.getActivosAhora().subscribe({
      next: (activos) => {
        this.flotaFuncionandoAhora = activos.length;
        this.loading = false;
      },
      error: () => {
        this.flotaFuncionandoAhora = 0;
        this.loading = false;
      }
    });
  }

  private isGvActivoEnViaje(gv: any): boolean {
    const autorizado = Number(gv?.autorizado) === 1;
    const cerrado = Number(gv?.cerrado) === 1;
    const salida = this.toDate(gv?.fecha_hora_salida);
    const llegada = this.toDate(gv?.fecha_hora_llegada);
    const now = Date.now();

    if (!autorizado || cerrado || !salida || !llegada) return false;

    return salida.getTime() <= now && now <= llegada.getTime();
  }

  private toDate(value: unknown): Date | null {
    if (!value) return null;
    const parsed = new Date(value as string | number | Date);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  get kmsRecorridosLabel(): string {
    return this.kmsRecorridos.toLocaleString('es-AR');
  }
}
